import React from 'react';

export const IconCheckCircleOutline: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
        <circle cx="12" cy="12" r="9.75" />
        <path d="M8 12.25L10.75 15L16 9.25" />
    </svg>
);
